import { fromJS, List } from 'immutable';
import { UPDATE_ROOMS } from '../constants/rooms';
import { CLEAR_SEARCHER_FILTERS_ON_SET_TABS } from '../constants/extraItems';

const initialState = List();

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_ROOMS: {
      const [firstRoom] = action.payload;
      if (firstRoom?.lt_extras) {
        return fromJS(firstRoom.lt_extras);
      }
      return state;
    }
    case CLEAR_SEARCHER_FILTERS_ON_SET_TABS:
      return initialState;
    default:
      return state;
  }
}
